import React from 'react';
import { Box, Typography } from '@mui/material';

const ChatSignature = ({ chatData }) => (
  <Box
    sx={{
      color: 'black',
      fontSize: 14,
      marginTop: '4px', // Add some space between the message and the signature
      display: 'flex',
      justifyContent: 'flex-end',
    }}
  >
    <Typography variant="body2">
      {chatData.sender_first_name} {chatData.sender_last_name} -{' '}
      {new Date(chatData.sent_timestamp).toLocaleTimeString([], {
        timeStyle: 'short',
      })}
    </Typography>
  </Box>
);

export default ChatSignature;
